// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/billing/v1/list_credit_transactions.proto (package protos.vision.billing.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { CreditTransaction } from "./vision_billing_pb";
import { file_vision_billing_v1_vision_billing } from "./vision_billing_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/billing/v1/list_credit_transactions.proto.
 */
export const file_vision_billing_v1_list_credit_transactions: GenFile = /*@__PURE__*/
  fileDesc("CjB2aXNpb24vYmlsbGluZy92MS9saXN0X2NyZWRpdF90cmFuc2FjdGlvbnMucHJvdG8SGHByb3Rvcy52aXNpb24uYmlsbGluZy52MSKWAgodTGlzdENyZWRpdFRyYW5zYWN0aW9uc1JlcXVlc3QSTgoGcGFyYW1zGAEgASgLMj4ucHJvdG9zLnZpc2lvbi5iaWxsaW5nLnYxLkxpc3RDcmVkaXRUcmFuc2FjdGlvbnNSZXF1ZXN0LlBhcmFtcxJWCgpwYWdpbmF0aW9uGAIgASgLMkIucHJvdG9zLnZpc2lvbi5iaWxsaW5nLnYxLkxpc3RDcmVkaXRUcmFuc2FjdGlvbnNSZXF1ZXN0LlBhZ2luYXRpb24aCAoGUGFyYW1zGkMKClBhZ2luYXRpb24SEQoJcGFnZV9zaXplGAEgASgFEhQKCm5leHRfdG9rZW4YAiABKAlIAEIMCgpwYWdlX3Rva2VuIr4CCh5MaXN0Q3JlZGl0VHJhbnNhY3Rpb25zUmVzcG9uc2USTwoGcmVzdWx0GAEgASgLMj8ucHJvdG9zLnZpc2lvbi5iaWxsaW5nLnYxLkxpc3RDcmVkaXRUcmFuc2FjdGlvbnNSZXNwb25zZS5SZXN1bHQSVwoKcGFnaW5hdGlvbhgCIAEoCzJDLnByb3Rvcy52aXNpb24uYmlsbGluZy52MS5MaXN0Q3JlZGl0VHJhbnNhY3Rpb25zUmVzcG9uc2UuUGFnaW5hdGlvbhpLCgZSZXN1bHQSQQoMdHJhbnNhY3Rpb25zGAEgAygLMisucHJvdG9zLnZpc2lvbi5iaWxsaW5nLnYxLkNyZWRpdFRyYW5zYWN0aW9uGiUKClBhZ2luYXRpb24SFwoPbmV4dF9wYWdlX3Rva2VuGAEgASgJYgZwcm90bzM", [file_vision_billing_v1_vision_billing]);

/**
 * @generated from message protos.vision.billing.v1.ListCreditTransactionsRequest
 */
export type ListCreditTransactionsRequest = Message<"protos.vision.billing.v1.ListCreditTransactionsRequest"> & {
  /**
   * @generated from field: protos.vision.billing.v1.ListCreditTransactionsRequest.Params params = 1;
   */
  params?: ListCreditTransactionsRequest_Params | undefined;

  /**
   * @generated from field: protos.vision.billing.v1.ListCreditTransactionsRequest.Pagination pagination = 2;
   */
  pagination?: ListCreditTransactionsRequest_Pagination | undefined;
};

/**
 * Describes the message protos.vision.billing.v1.ListCreditTransactionsRequest.
 * Use `create(ListCreditTransactionsRequestSchema)` to create a new message.
 */
export const ListCreditTransactionsRequestSchema: GenMessage<ListCreditTransactionsRequest> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_list_credit_transactions, 0);

/**
 * @generated from message protos.vision.billing.v1.ListCreditTransactionsRequest.Params
 */
export type ListCreditTransactionsRequest_Params = Message<"protos.vision.billing.v1.ListCreditTransactionsRequest.Params"> & {
};

/**
 * Describes the message protos.vision.billing.v1.ListCreditTransactionsRequest.Params.
 * Use `create(ListCreditTransactionsRequest_ParamsSchema)` to create a new message.
 */
export const ListCreditTransactionsRequest_ParamsSchema: GenMessage<ListCreditTransactionsRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_list_credit_transactions, 0, 0);

/**
 * @generated from message protos.vision.billing.v1.ListCreditTransactionsRequest.Pagination
 */
export type ListCreditTransactionsRequest_Pagination = Message<"protos.vision.billing.v1.ListCreditTransactionsRequest.Pagination"> & {
  /**
   * @generated from field: int32 page_size = 1;
   */
  pageSize: number;

  /**
   * @generated from oneof protos.vision.billing.v1.ListCreditTransactionsRequest.Pagination.page_token
   */
  pageToken: {
    /**
     * @generated from field: string next_token = 2;
     */
    value: string;
    case: "nextToken";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message protos.vision.billing.v1.ListCreditTransactionsRequest.Pagination.
 * Use `create(ListCreditTransactionsRequest_PaginationSchema)` to create a new message.
 */
export const ListCreditTransactionsRequest_PaginationSchema: GenMessage<ListCreditTransactionsRequest_Pagination> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_list_credit_transactions, 0, 1);

/**
 * @generated from message protos.vision.billing.v1.ListCreditTransactionsResponse
 */
export type ListCreditTransactionsResponse = Message<"protos.vision.billing.v1.ListCreditTransactionsResponse"> & {
  /**
   * @generated from field: protos.vision.billing.v1.ListCreditTransactionsResponse.Result result = 1;
   */
  result?: ListCreditTransactionsResponse_Result | undefined;

  /**
   * @generated from field: protos.vision.billing.v1.ListCreditTransactionsResponse.Pagination pagination = 2;
   */
  pagination?: ListCreditTransactionsResponse_Pagination | undefined;
};

/**
 * Describes the message protos.vision.billing.v1.ListCreditTransactionsResponse.
 * Use `create(ListCreditTransactionsResponseSchema)` to create a new message.
 */
export const ListCreditTransactionsResponseSchema: GenMessage<ListCreditTransactionsResponse> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_list_credit_transactions, 1);

/**
 * @generated from message protos.vision.billing.v1.ListCreditTransactionsResponse.Result
 */
export type ListCreditTransactionsResponse_Result = Message<"protos.vision.billing.v1.ListCreditTransactionsResponse.Result"> & {
  /**
   * @generated from field: repeated protos.vision.billing.v1.CreditTransaction transactions = 1;
   */
  transactions: CreditTransaction[];
};

/**
 * Describes the message protos.vision.billing.v1.ListCreditTransactionsResponse.Result.
 * Use `create(ListCreditTransactionsResponse_ResultSchema)` to create a new message.
 */
export const ListCreditTransactionsResponse_ResultSchema: GenMessage<ListCreditTransactionsResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_list_credit_transactions, 1, 0);

/**
 * @generated from message protos.vision.billing.v1.ListCreditTransactionsResponse.Pagination
 */
export type ListCreditTransactionsResponse_Pagination = Message<"protos.vision.billing.v1.ListCreditTransactionsResponse.Pagination"> & {
  /**
   * @generated from field: string next_page_token = 1;
   */
  nextPageToken: string;
};

/**
 * Describes the message protos.vision.billing.v1.ListCreditTransactionsResponse.Pagination.
 * Use `create(ListCreditTransactionsResponse_PaginationSchema)` to create a new message.
 */
export const ListCreditTransactionsResponse_PaginationSchema: GenMessage<ListCreditTransactionsResponse_Pagination> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_list_credit_transactions, 1, 1);

